export class UrlMaxLen {
  urlschema: number;
  host: number;
  pfad: number;
  query: number;
  fragment: number;
}